// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as V3QuestionsApi$LiteracyplanetTupperware from "./V3QuestionsApi.res.mjs";
import * as V3StylePreferences$LiteracyplanetTupperware from "./V3StylePreferences.res.mjs";

function PilotStemHeading$RenderStemInQuestionContainer(props) {
  var match = Curry._1(V3QuestionsApi$LiteracyplanetTupperware.use, undefined);
  return React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
              id: "stemContainerQuestion-" + String(match.questionIndex),
              children: React.createElement("h1", {
                    className: "PilotStemHeading"
                  }, React.createElement("div", {
                        className: "pilot-heading"
                      }, props.children))
            });
}

var RenderStemInQuestionContainer = {
  make: PilotStemHeading$RenderStemInQuestionContainer
};

function PilotStemHeading(props) {
  var children = props.children;
  var match = V3StylePreferences$LiteracyplanetTupperware.usePrefs();
  if (match.floatingStem) {
    return React.createElement(PilotStemHeading$RenderStemInQuestionContainer, {
                children: children
              });
  } else {
    return React.createElement("div", {
                className: "pilot-heading2"
              }, children);
  }
}

var make = PilotStemHeading;

export {
  RenderStemInQuestionContainer ,
  make ,
}
/* react Not a pure module */
